const bone = $('#SingleOptionSelector-1-0');
const graphite = $('#SingleOptionSelector-1-1');
const natural = $('#SingleOptionSelector-1-2');
const teak = $('#SingleOptionSelector-1-3');
const cartBtn = document.querySelector('#js-product-add-related-cart-button');
const unpacking = $('#unselect_packing_cost');

teak.click(function () {
  console.log(teak.val());
  cartBtn.classList.add('text_link_orange_cv_soldout');
  cartBtn.innerText = '売り切れ';
  cartBtn.type = 'button';
  cartBtn.disabled = true;
});

bone.click(function () {
  cartBtn.classList.remove('text_link_orange_cv_soldout');
  cartBtn.classList.add('product_add_related_footer_add_cart_button_text');
  cartBtn.innerText = 'カートに追加する';
  cartBtn.type = 'submit';
  cartBtn.disabled = false;
});

graphite.click(function () {
  cartBtn.classList.remove('text_link_orange_cv_soldout');
  cartBtn.classList.add('product_add_related_footer_add_cart_button_text');
  cartBtn.innerText = 'カートに追加する';
  cartBtn.type = 'submit';
  cartBtn.disabled = false;
});

natural.click(function () {
  cartBtn.classList.remove('text_link_orange_cv_soldout');
  cartBtn.classList.add('product_add_related_footer_add_cart_button_text');
  cartBtn.innerText = 'カートに追加する';
  cartBtn.type = 'submit';
  cartBtn.disabled = false;
});
